import {
  AtSign,
  Bell,
  Eye,
  FileText,
  LayoutDashboard,
  Clipboard,
  Link,
  LucideIcon,
  Mail,
  MailOpen,
  MessageSquare,
  TrendingUp,
  User,
  Sparkles,
  UserMinus
} from "lucide-react"
import { Activity } from "../../../../types"
import { cn } from "../../../utils"

// Activity type color mapping - ensures Tailwind JIT detects all classes
const ACTIVITY_TYPE_COLORS: Record<string, string> = {
  new_lead: "text-purple-700 bg-purple-100",
  new_subscription: "text-blue-600 bg-blue-100",
  dashboard_update: "text-cyan-700 bg-cyan-100",
  dashboard_pageview: "text-cyan-700 bg-cyan-100",
  dashboard_first_visit: "text-red-700 bg-red-100",
  dashboard_initial_visit: "text-red-700 bg-red-100",
  intro_email_sent: "text-green-700 bg-green-100",
  sms_followup_sent: "text-green-700 bg-green-100",
  intro_email_opened: "text-emerald-700 bg-emerald-100",
  intro_email_clicked: "text-emerald-700 bg-emerald-100",
  loan_summary_pdf: "text-stone-700 bg-stone-100",
  loan_summary_jpeg: "text-stone-700 bg-stone-100",
  unsubscribed: "text-rose-700 bg-rose-100",
  dashboard_ai_created: "text-violet-700 bg-violet-100"
}

const CATEGORY_DEFAULT_COLORS: Record<string, string> = {
  lead: "text-teal-700 bg-teal-100",
  subscription: "text-pink-700 bg-pink-100"
}

const getActivityTypeColor = (type: string, category: string): string => {
  return (
    ACTIVITY_TYPE_COLORS[type] ??
    CATEGORY_DEFAULT_COLORS[category] ??
    "text-gray-700 bg-gray-100"
  )
}

const Icon = ({
  activity,
  className,
  strokeWidth
}: {
  activity: Activity
  className: string
  strokeWidth: number
}) => {
  let Icon: LucideIcon = Clipboard

  const { type, category } = activity
  switch (type) {
    case "new_lead":
      Icon = User
      break
    case "new_subscription":
      Icon = AtSign
      break
    case "dashboard_update":
      Icon = TrendingUp
      break
    case "dashboard_pageview":
      Icon = Eye
      break
    case "dashboard_first_visit":
    case "dashboard_initial_visit":
      Icon = LayoutDashboard
      break
    case "intro_email_sent":
      Icon = Mail
      break
    case "sms_followup_sent":
      Icon = MessageSquare
      break
    case "intro_email_opened":
      Icon = MailOpen
      break
    case "intro_email_clicked":
      Icon = Link
      break
    case "loan_summary_pdf":
    case "loan_summary_jpeg":
      Icon = FileText
      break
    case "dashboard_ai_created":
      Icon = Sparkles
      break
    case "unsubscribed":
      Icon = UserMinus
      break
    default:
      Icon =
        category === "lead"
          ? User
          : category === "subscription"
          ? Bell
          : Clipboard
      break
  }
  return <Icon className={className} strokeWidth={strokeWidth} />
}

const ActivityIcon = ({ activity }: { activity: Activity }) => {
  const activityColor = getActivityTypeColor(activity.type, activity.category)

  return (
    <div
      className={cn(
        "w-8 h-8 rounded-full bg-gradient-to-br flex items-center justify-center",
        activityColor
      )}
    >
      <Icon
        activity={activity}
        className="w-4 sm:w-3.5 h-4 sm:h-3.5"
        strokeWidth={2.5}
      />
    </div>
  )
}

export default ActivityIcon
